import { CommonModule } from '@angular/common';
import { Component, HostBinding, Input, TemplateRef, ViewContainerRef } from '@angular/core';

@Component({
  selector: 'app-custom-toastr-message',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './custom-toastr-message.component.html',
  styleUrl: './custom-toastr-message.component.scss'
})
export class CustomToastrMessageComponent {
  @Input() messageText: string;
  @Input() messageTemplate: TemplateRef<any>;
  @Input() shouldCenter: boolean = true;
  @HostBinding('class.centered') get isCentered() {
    return this.shouldCenter;
  }
}
